module.exports = __webpack_public_path__ + "img/download.0eafb6f0.svg";